import { isApp } from "./isApp";

let logMetricsCache: boolean = false;

export async function initLogMetrics(): Promise<void> {
  if (!isApp) {
    logMetricsCache = false;
    return;
  }
  const { invoke } = await import("@tauri-apps/api/core");
  logMetricsCache = await invoke<boolean>("should_log_metrics_cmd");
}

export function shouldLogMetrics(): boolean {
  return logMetricsCache;
}
